import Vue from "vue";
import App from "./App.vue";
import Vuelidate from "vuelidate";
import axios from "axios";
import router from "./router";
import { initUxcam } from "./services/uxcam";
import { installUxcamHooks } from "./services/uxcamHooks";

import { BootstrapVue } from "bootstrap-vue";
// Register only the icons actually used in templates instead of the full
// IconsPlugin (~300 components). `<b-icon icon="...">` resolves a named icon
// from the global registry, so each used icon component must be registered.
import {
  BIcon,
  BIconArrowRepeat,
  BIconArrowRight,
  BIconCalendarCheck,
  BIconCameraFill,
  BIconCardChecklist,
  BIconCashCoin,
  BIconExclamationTriangleFill,
  BIconHeartFill,
  BIconInfoCircle,
  BIconInfoCircleFill,
  BIconKeyFill,
  BIconMegaphoneFill,
  BIconPersonBadge,
  BIconTagFill,
  BIconTruck,
  BIconXCircle,
} from "bootstrap-vue";

Vue.use(BootstrapVue);
Vue.use(Vuelidate);

// Start the recorder before the app renders so the login screen is captured
// too, and wire the global toast / error / API-failure listeners.
initUxcam();
installUxcamHooks(Vue, axios);

[
  ["BIcon", BIcon],
  ["BIconArrowRepeat", BIconArrowRepeat],
  ["BIconArrowRight", BIconArrowRight],
  ["BIconCalendarCheck", BIconCalendarCheck],
  ["BIconCameraFill", BIconCameraFill],
  ["BIconCardChecklist", BIconCardChecklist],
  ["BIconCashCoin", BIconCashCoin],
  ["BIconExclamationTriangleFill", BIconExclamationTriangleFill],
  ["BIconHeartFill", BIconHeartFill],
  ["BIconInfoCircle", BIconInfoCircle],
  ["BIconInfoCircleFill", BIconInfoCircleFill],
  ["BIconKeyFill", BIconKeyFill],
  ["BIconMegaphoneFill", BIconMegaphoneFill],
  ["BIconPersonBadge", BIconPersonBadge],
  ["BIconTagFill", BIconTagFill],
  ["BIconTruck", BIconTruck],
  ["BIconXCircle", BIconXCircle],
].forEach(([name, component]) => Vue.component(name, component));

Vue.prototype.$http = axios;
Vue.prototype.$http.defaults.headers.common[
  "Request-Token"
] = `${process.env.VUE_APP_SEC_HEADER}`;
Vue.prototype.$http.defaults.headers.common["strict-transport-security"] =
  "max-age=31536000; includeSubDomains";
axios.defaults.headers.common[
  "Request-Token"
] = `${process.env.VUE_APP_SEC_HEADER}`;
axios.defaults.headers.common["strict-transport-security"] =
  "max-age=31536000; includeSubDomains";

import "bootstrap/dist/css/bootstrap.css";
import "bootstrap-vue/dist/bootstrap-vue.css";

Vue.config.productionTip = false;

new Vue({
  router,
  render: (h) => h(App),
}).$mount("#app");
